import { User, BasicUser } from "features/User/models";
import { isTaskActive } from ".";
import { NOT_COUNTED_TASK_STATUSES, RECENTLY_REMINDED_WINDOW_HOURS } from "../constants";
import { Task } from "../models";

export function tasksByStatusGroup(tasks: Task[] | undefined) {
  if (!tasks?.length) {
    return {
      active: [], completed: [], urgent: [], upcoming: [], all: [],
    };
  }

  const result = tasks.reduce(
    (acc, task) => {
      // Skip tasks that shouldn't be counted
      if (NOT_COUNTED_TASK_STATUSES.includes(task.status)) {
        return acc;
      }

      // Add to all (counted tasks)
      acc.all.push(task);

      // Check if task was reminded within the exclusion window
      const wasRecentlyReminded = task.lastReminderAt
        && ((Date.now() - new Date(task.lastReminderAt).getTime()) / (1000 * 60 * 60)) < RECENTLY_REMINDED_WINDOW_HOURS;

      // Count as urgent only if not overdue (overdue takes precedence) and not recently reminded
      if (task?.isUrgent && !task?.isOverdue && !wasRecentlyReminded) {
        acc.urgent.push(task);
      }
      // Categorize the task
      if (task?.status === "upcoming") {
        acc.upcoming.push(task);
      } else if (isTaskActive(task)) {
        acc.active.push(task);
      } else if (task?.status === "completed") {
        acc.completed.push(task);
      }

      return acc;
    },
    {
      active: [], completed: [], urgent: [], upcoming: [], all: [],
    } as {
      active: Task[];
      completed: Task[];
      urgent: Task[];
      upcoming: Task[];
      all: Task[];
    },
  );

  // Validation check
  const categorizedCount = result.upcoming.length + result.active.length + result.completed.length;
  if (categorizedCount !== result.all.length) {
    console.error(`Error: Adding up doesn't add ${categorizedCount} : ${result.all.length}`, result);
  }

  return result;
}

export function groupTasksByUser(tasks: Task[] | undefined, userMap: Record<string, User | BasicUser | undefined>) {
  if (!tasks || !userMap) {
    return {};
  }
  const returnObj: Record<string, any> = {};
  Object.keys(userMap).forEach((key) => {
    const user = userMap[key];
    if (user) {
      returnObj[key] = tasks.filter((task) => task.assigneeId === user.id);
    }
  });
  return returnObj;
}
